var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../theme-provider';
import { GalleryContext } from './gallery';
export const StyledSlide = styled.div.withConfig({ displayName: "StyledSlide", componentId: "sc-196wn05" }) `display:flex;flex-grow:0;flex-shrink:0;align-items:start;justify-content:center;scroll-snap-align:${({ withScrollSnap }) => withScrollSnap ? 'start' : 'none'};outline:none;opacity:${({ fadeout }) => fadeout && '0.5'};transition:opacity 0.5s ease-in-out;`;
const StyledContainedImageWrapper = styled.div.withConfig({ displayName: "StyledContainedImageWrapper", componentId: "sc-9lvcex" }) `width:${(props) => props.reduceImageSize
    ? `calc(100% - 2 * ${props.theme.size.grid001})`
    : '100%'};`;
export const GallerySlide = (_a) => {
    var { ariaLabel, ariaLabelledby, children, 'aria-label': ariaLabelNative, 'aria-labelledby': ariaLabelledbyNative } = _a, rest = __rest(_a, ["ariaLabel", "ariaLabelledby", "children", 'aria-label', 'aria-labelledby']);
    const { getSlideId, slidesPerPage, fadingEdges, accessibleExtendedIndices, visibleIndices, snappableExtendedIndices, } = React.useContext(GalleryContext);
    const { index: slideIndex, id = NaN } = React.useContext(GallerySlideContext);
    // id (extendedIndex): -2 -1           5 6
    // slideIndex (index):  3  4 0 1 2 3 4 0 1
    const slideId = id || slideIndex;
    const isCopyOfASlide = !Number.isNaN(id);
    // To ensure that screenreaders read out the correct amount of slides in the gallery,
    // hide slide copies from aria when not in view and hide normal slides when their
    // copy gets in to view.
    const ariaHidden = isCopyOfASlide
        ? !accessibleExtendedIndices.includes(slideId)
        : visibleIndices.includes(slideIndex) &&
            !accessibleExtendedIndices.includes(slideIndex);
    return (React.createElement(StyledSlide, Object.assign({ id: getSlideId(slideId), fadeout: fadingEdges && !visibleIndices.includes(slideIndex), "data-accessible": accessibleExtendedIndices.includes(slideId), role: "group", "aria-label": ariaLabelNative ? ariaLabelNative : ariaLabel, "aria-labelledby": ariaLabelledbyNative ? ariaLabelledbyNative : ariaLabelledby, "aria-roledescription": "slide", "aria-hidden": ariaHidden ? true : undefined, withScrollSnap: snappableExtendedIndices.includes(slideIndex) }, rest),
        React.createElement(StyledContainedImageWrapper, { reduceImageSize: slidesPerPage === 1 }, children)));
};
export const GallerySlideContext = React.createContext({
    index: 0,
});
